var OAuthTypeEnum;
(function (OAuthTypeEnum) {
    OAuthTypeEnum["apple"] = "apple";
    OAuthTypeEnum["google"] = "google";
    OAuthTypeEnum["fb"] = "facebook";
})(OAuthTypeEnum || (OAuthTypeEnum = {}));
var OAuthResponseStatusEnum;
(function (OAuthResponseStatusEnum) {
    OAuthResponseStatusEnum["ok"] = "ok";
    OAuthResponseStatusEnum["error"] = "error";
})(OAuthResponseStatusEnum || (OAuthResponseStatusEnum = {}));

var ROUTE_PREFIX = "/package/auth";
var ENDPOINT_PACKAGE_VERSION = ROUTE_PREFIX + "/version";
// Auth
var ENDPOINT_AUTH = ROUTE_PREFIX + "/auth";
// Email Password Reset
var ENDPOINT_EMAIL_PASSWORD_RESET = ROUTE_PREFIX + "/email/password-reset";
// Contacts Email Verification
var ENDPOINT_CONTACTS_EMAIL_VERIFICATION = ROUTE_PREFIX + "/contacts/email/verification";
// Current user
var ENDPOINT_USERS_CURRENT = ROUTE_PREFIX + "/users/current";
// Users Validate Password reset token
var ENDPOINT_USERS_VALIDATE_PASSWORD_RESET_TOKEN = ROUTE_PREFIX + "/users/validate-password-reset-token";
// Users Reset Password
var ENDPOINT_USERS_RESET_PASSWORD = ROUTE_PREFIX + "/users/reset-password";
// Users email
var ENDPOINT_USERS_EMAIL = ROUTE_PREFIX + "/users/email";
// Users Password
var ENDPOINT_USERS_PASSWORD = ROUTE_PREFIX + "/users/password";
// Auth Email
var ENDPOINT_AUTH_EMAIL = ROUTE_PREFIX + "/auth/email";
// Auth Logout
var ENDPOINT_AUTH_LOGOUT = ROUTE_PREFIX + "/auth/logout";
// Auth OAuth
var generateOAuthEndpoint = function (type) {
    return ROUTE_PREFIX + "/auth/" + type;
};

var PATH_OAUTH_RESPONSE = "/oauth/response";
var PATH_RECOVER_PASSWORD = "/recover-password";
var PATH_UPDATE_EMAIL_VERIFICATION = "/verification";

/* eslint-disable import/prefer-default-export */
var isVersionCompatible = function (feVersion, beVersion) {
    var feBreaking = feVersion.split(".")[0];
    var feIsNumber = !Number.isNaN(Number(feBreaking));
    var beBreaking = beVersion.split(".")[0];
    var beIsNumber = !Number.isNaN(Number(beBreaking));
    return feIsNumber && beIsNumber && beBreaking === feBreaking;
};

export { ENDPOINT_AUTH, ENDPOINT_AUTH_EMAIL, ENDPOINT_AUTH_LOGOUT, ENDPOINT_CONTACTS_EMAIL_VERIFICATION, ENDPOINT_EMAIL_PASSWORD_RESET, ENDPOINT_PACKAGE_VERSION, ENDPOINT_USERS_CURRENT, ENDPOINT_USERS_EMAIL, ENDPOINT_USERS_PASSWORD, ENDPOINT_USERS_RESET_PASSWORD, ENDPOINT_USERS_VALIDATE_PASSWORD_RESET_TOKEN, OAuthResponseStatusEnum, OAuthTypeEnum, PATH_OAUTH_RESPONSE, PATH_RECOVER_PASSWORD, PATH_UPDATE_EMAIL_VERIFICATION, ROUTE_PREFIX, generateOAuthEndpoint, isVersionCompatible };
//# sourceMappingURL=index.esm.js.map
